/** CRM interaction types that deduct from service package entitlements when completed. */
export const CRM_TRACKABLE_TYPES = {
  interview: { label: 'Mock interview session', usesDuration: false },
  call: { label: 'Consultant minutes', usesDuration: true, defaultDuration: 15 },
  video_call: { label: 'Consultant minutes', usesDuration: true, defaultDuration: 30 },
  meeting: { label: 'Consultant minutes', usesDuration: true, defaultDuration: 60 },
};

export const CRM_DURATION_TYPES = Object.entries(CRM_TRACKABLE_TYPES)
  .filter(([, cfg]) => cfg.usesDuration)
  .map(([key]) => key);

export function isTrackableCrmType(type) {
  return Boolean(CRM_TRACKABLE_TYPES[type]);
}

export function defaultDurationForType(type) {
  return CRM_TRACKABLE_TYPES[type]?.defaultDuration || null;
}
